import { render } from "./LoadingButton.vue?vue&type=template&id=44727da5&scoped=true"
import script from "./LoadingButton.vue?vue&type=script&lang=js"
export * from "./LoadingButton.vue?vue&type=script&lang=js"

import "./LoadingButton.vue?vue&type=style&index=0&id=44727da5&scoped=true&lang=css"

import exportComponent from "/deploy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44727da5"]])

export default __exports__